import i18n from '@/i18n.js';

export default {
    itemsByType: function (state) {
        return function (typeId) {
            return state.configurator.items.filter(function (item) {
                return item.type == typeId;
            });
        };
    },
    fillingItems: function (state) {
        return function (typeId) {
            var fillingTypeId = state.fillingMapping[typeId.toString()];
            return state.configurator.items.filter(function (item) {
                return item.type == fillingTypeId;
            });
        }
    },
    typeGroups : function(state) {
        return state.productTypes.map(function (item) {
            return item.groupCode;
        }).filter(function(value, index, self) {
            return self.indexOf(value) === index;
        });
    },
    collectionNameLowercase: function(state) {
        return state.collectionName.toLowerCase();
    },
    currentCollectionId: function (state) {
        return state.collectionId;
    },
    currentCollectionType: function (state) {
        return state.collectionType;
    },
    packQuantity: function (state) {
        return function (collectionId) {
            var pack = state.configurator.packs.find(function (item) {
                return item.collectionId == collectionId;
            });
            if (!pack) {
                return 1;
            }
            return pack.quantity;
        };
    },
    isLoadingConfigurator: function (state) {
        return state.loadingContent;
    },
    getProductTypes: function (state) {
        return state.productTypes;
    },
    getProductTypeTexts: function (state) {
        return state.productTypeTexts;
    },
    isSelectedSet: function (state) {
        return state.configurator.hasSelectedSet;
    },
    isSelectedThisSet: function (state) {
        return function (setId) {

            var selectedSet = state.configurator.selectedProductSetId || 0;
            return state.configurator.hasSelectedSet && selectedSet === setId;
        };
    },
    getSelectedSet: function (state) {
        return state.productSets.find(function (set) {
            return set.id === state.configurator.selectedProductSetId;
        });
    },
    getVariantsForType: function (state) {
        return function (typeId) {
            return state.variantInfos.filter(function (variant) {
                return variant.productType.id == typeId;
            });
        }
    },
    getVariantById: function (state) {
        return function (id) {
            return state.variantInfos.find(function (variant) {
                return variant.variantId == id;
            });
        }
    },
    getVariantsFor: function (state) {
        return function (item) {
            let variants = state.variantInfos.filter(function (variant) {
                var condition = variant.productType.id == item.type;
                if (!condition) {
                    return false;
                }
                item.parameters.forEach(function (tp) {
                    var varTp = variant.technicalParameters.find(function (varTp) {
                        return varTp.id == tp.id;
                    });
                    if (!varTp) {
                        condition = false;
                        return;
                    }
                    var sameValue = false;
                    if (tp.type != "checkbox" && typeof tp.value != "boolean") {
                        sameValue = varTp.value.id == tp.value;
                    } else {
                        sameValue = varTp.value.value == tp.value;
                    }
                    condition = condition && sameValue;
                });
                return condition;
            });
            return variants;
        };
    },
    getTechnicalParameters: function (state) {
        // returns all technical parameters for provided productTypeId
        return function (productTypeId) {
            return state.variantInfos
                .filter(function (item) {
                    return item.productType.id == productTypeId;
                })
                .map(function (item) {
                    return item.technicalParameters;
                })
                .flat()
                .uniqueObject("id");
        };
    },
    getTechnicalParameterIntersection(state, getters) {
        return function (productTypeIdA, productTypeIdB) {
            var tpA = getters.getTechnicalParameters(productTypeIdA);
            var tpB = getters.getTechnicalParameters(productTypeIdB);
            var tpBIds = tpB.map(function (item) {
                return item.id;
            })
            return tpA.filter(function (item) {
                return tpBIds.indexOf(item.id) >= 0;
            })
        }
    },
    convertTechnicalParameter: function () { // converts technical parameter to unified format for printing
        return function (technicalParameter) {
            switch (technicalParameter.id) {
                case 1079:
                    return {
                        name: technicalParameter.name,
                        value: technicalParameter.value.value ? i18n.t('common.oxfordStyle') : ''
                    };
                default:
                    return {
                        name: technicalParameter.name,
                        value: technicalParameter.value.value
                    };
            }
        };
    },
    getTPValues: function (state) {
        return function (productType, tpType, chainedId) {
            if (chainedId == null) {
                var values = state.variantInfos
                    .filter(function (item) {
                        return item.productType.id == productType;
                    })
                    .map(function (item) {
                        return item.technicalParameters.filter(function (tp) {
                            return tp.id == tpType;
                        });
                    })
                    .flat()
                    .map(function (item) {
                        return item.value;
                    })
                    .uniqueObject("id");
                return values;
            } else {
                var chainedGroups = [];
                var onlyTypeVariants = state.variantInfos.filter(function (item) {
                    return item.productType.id == productType;
                });
                onlyTypeVariants.forEach(function(item) {
                    var chained = item.technicalParameters.find(function (tp) {
                        return tp.id == chainedId;
                    });
                    if (!chained) {
                        return;
                    }
                    var current = item.technicalParameters.find(function (tp) {
                        return tp.id == tpType;
                    });
                    // find if already exists
                    var group = chainedGroups.find(
                        function (chItem) {return chItem.chainedValue.id == chained.value.id && chItem.values[0].id == current.value.id;}
                    );
                    if (!group) {
                        group = {
                            chainedId: chainedId,
                            chainedValue: chained.value,
                            values: []
                        };
                        chainedGroups.push(group);
                    }
                    var cValue = JSON.parse(JSON.stringify(current.value));
                    if(tpType === 1086) {
                        cValue.value += ' ' + item.fabric;
                    }
                    group.values.push(cValue);
                    group.values = group.values.uniqueObject("id");
                });
                return chainedGroups;
            }
        };
    },
    getSelectedProducts: function (state, getters) {
        var variants = state.configurator.items
            .map(function (item) {
                if (item.isCustom) {
                    //Product with custom parameters (dimensions)
                    let dimensionsText = '';
                    if ('customParameters' in item) {
                        item.customParameters.forEach(function(param) {
                            if (param.type == 'type-dimensions') {
                                dimensionsText += param.value.width + 'x' + param.value.length + i18n.t('store.getters.cm');
                            }
                        });
                    }
                    let array = [
                        {
                            isCustom: item.isCustom,
                            quantity: item.quantity,
                            customParameters: item.customParameters,
                            type: item.type,
                            uid: item.uid,
                            variantInfo: {
                                name: item.name + ' ' + dimensionsText,
                                price: item.customPrice,
                                collectionId: state.collectionId
                            }
                        }
                    ];
                    return array;
                }
                var vars = getters.getVariantsFor(item);
                if (vars.length !== 1) {
                    return [];
                }
                return vars.map(function (variant) {
                    return {
                        quantity: item.quantity,
                        variantInfo: variant,
                        uid: item.uid
                    };
                });
            })
            .flat()
            .reduce(function (grouped, product) {
                var item = grouped.find(function(g) {
                        if (!g.isCustom) {
                            g.variantInfo.variantId == product.variantInfo.variantId;
                        }
                    }
                );
                if (!item) {
                    grouped.push(product);
                } else {
                    item.quantity = item.quantity + product.quantity;
                }
                return grouped;
            }, []);
        return variants;
    },
    getResumeSets: function (state, getters) {
        var resumeSets = [];
        getters.getSelectedProducts.forEach(function (product) {
            var productCollectionId = product.variantInfo.collectionId;
            if (!state.constructor.collectionFixed && productCollectionId === 15) { // sheet shit
                productCollectionId = state.configurator.collectionId;
            }
            var currentResumeSet = resumeSets.find(function (set) {
                return set.collectionId === productCollectionId;
            });
            if (!currentResumeSet) {
                let quantity = 1;
                let pack = state.configurator.packs.find(function (p) {
                    return p.collectionId === productCollectionId;
                });
                if (pack) {
                    quantity = pack.quantity;
                }

                let selectedProductSet = null;
                if (productCollectionId === state.collectionId) {
                    // currently selected product set
                    selectedProductSet = state.productSets.find(function (set) {
                        return state.configurator.selectedProductSetId == set.id;
                    });
                }
                var collectionId = product.variantInfo.collectionId;
                var collectionName = state.collectionName;
                if (collectionId !== state.collectionId) {
                    switch (collectionId) {
                        case 2:
                            collectionName = i18n.t('common.fillings');
                            break;
                        case 15:
                            collectionName = i18n.t('common.sheets');
                            break;
                    }
                }
                currentResumeSet = {
                    name: collectionName,
                    collectionId: collectionId,
                    productSet: selectedProductSet,
                    items: [],
                    quantity: quantity
                };
                resumeSets.push(currentResumeSet);
            }
            currentResumeSet.items.push(product);
        });
        return resumeSets;
    },
    typeImages : function (state) {
        return function (type) {
            return state.images.filter(function(i) { return i.type === type; });
        }
    },
    variantImage : function (state) {
        return function (variantId, type) {
            if (state.variantImages[variantId]){
               return state.variantImages[variantId];
            }

            var productImages = state.images.filter(function(i) { return i.type === type; });
            return productImages[0] ? productImages[0] : null;
        }
    },
    localeTag: function (state) {
        return state.localeTag;
    }
};
